/**
 * Push events to GTM dataLayer
 * Used by analytics-context.js for CleverTap + GTM dual tracking
 */
export const pushToDataLayer = (eventName, eventData = {}) => {
  if (typeof window === "undefined") {
    return;
  }

  // Ensure dataLayer exists
  window.dataLayer = window.dataLayer || [];

  // Push event to dataLayer
  window.dataLayer.push({
    event: eventName,
    ...eventData,
  });
};
